import { render } from "./ParameterImage.vue?vue&type=template&id=2c7c55bf&scoped=true"
import script from "./ParameterImage.vue?vue&type=script&lang=js"
export * from "./ParameterImage.vue?vue&type=script&lang=js"

import "./ParameterImage.vue?vue&type=style&index=0&id=2c7c55bf&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7c55bf"]])

export default __exports__